/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SourceLinkView { 
    id?: string;
    projectId?: number;
    provider?: SourceLinkView.ProviderEnum;
    connectionSiteId?: string;
    siteName?: string;
    driveName?: string;
    folderPath?: string;
    folderWebUrl?: string;
    targetFolderId?: string;
    fileTypes?: Array<string>;
    status?: SourceLinkView.StatusEnum;
    syncing?: boolean;
    lastSyncAt?: Date;
    nextSyncAt?: Date;
    lastError?: string;
    fileCount?: number;
    skippedCount?: number;
}
export namespace SourceLinkView {
    export type ProviderEnum = 'SHAREPOINT';
    export const ProviderEnum = {
        SHAREPOINT: 'SHAREPOINT' as ProviderEnum
    };
    export type StatusEnum = 'INITIAL_SYNC' | 'ACTIVE' | 'ERROR' | 'PAUSED';
    export const StatusEnum = {
        INITIALSYNC: 'INITIAL_SYNC' as StatusEnum,
        ACTIVE: 'ACTIVE' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum,
        PAUSED: 'PAUSED' as StatusEnum
    };
}